<template>
    <v-container fluid>
        <!-- inicio de cambiar de rancho -->
        <v-row class="pa-0 ma-0 align-center"
               justify="center"
               no-gutters>
            <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
                <ChangeRanch
                    :paddock="paddockSelected"
                    :paddocks="currentPaddocks">
                </ChangeRanch>
            </v-col>
        </v-row>
        <!-- fin de cambiar de rancho -->

        <!-- inicio de texto principal -->
        <v-row class="my-3 px-2 smart-title-2 home-title-container-mobile"
               no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center">
                <div class="unselectable" style="text-align:center">Bienvenido -usuario- Elige una tarea para comenzar </div>
            </v-col>
        </v-row>
        <!-- fin de texto principal -->

        <!-- inicio de tarjetas de alertas -->
        <v-row flat elevation="5" class="ma-0">
            <!-- inicio de tarjeta email -->
            <v-col no-gutters cols="12" class="pa-0 my-2">
                <!-- inicio de tarjeta de email -->
                <v-card class="pa-0 ma-0">
                    <v-row class="card-width" no-gutters>
                        <!-- inicio de texto -->
                        <v-col cols="8"
                               class="pa-2 card-text">
                               Te enviaremos un <b>correo electronico</b> cuando alguna de tus vacas necesite de tu atencion, para registrar el evento.
                        </v-col>
                        <!-- fin de texto -->

                        <!-- inicio de icono -->
                        <v-col cols="4"
                               class="ltl-card-header-alert std-border-right-radius pa-2 align-center justify-center card-width"
                               >
                            <v-col cols="12"
                                   class="ltl-card-icon-container no-gutters mx-auto mt-0 pa-0 d-flexs align-end icon-container-heat">
                                <img src="../assets/Icon_Email.svg" alt="#"/>
                            </v-col>
                            <v-col class="pa-0 ma-0 pt-1"
                                   no-padding
                                   style="text-align: center; vertical-align: middle;"
                                   >
                                   <input type="checkbox">
                            </v-col>
                        </v-col>
                        <!-- fin de icono -->
                    </v-row>
                </v-card>
                <!-- fin de tarjeta de email -->
            </v-col>
            <!-- fin de tarjeta email -->

            <!-- inicio de tarjeta Alerta Web -->
            <v-col no-gutters cols="12" class="pa-0 my-2">
                <v-card class="pa-0 ma-0">
                    <v-row class="card-width" no-gutters>
                        <!-- inicio de texto -->
                        <v-col cols="8"
                               class="pa-2 card-text">
                               Te aparecera una <b>notificacion</b> en tu navegador cuando suceda algo ¡altamente recomendada!
                        </v-col>
                        <!-- fin de texto -->

                        <!-- inicio de icono -->
                        <v-col cols="4"
                               class="ltl-card-header-alert std-border-right-radius pa-2 align-center justify-center card-width"
                               >
                            <v-col cols="12"
                                   class="ltl-card-icon-container no-gutters mx-auto mt-0 pa-0 d-flexs align-end icon-container-heat">
                                <img src="../assets/Icon_WebAlert.svg" alt="#"/>
                            </v-col>
                            <v-col class="pa-0 ma-0 pt-1"
                                   no-padding
                                   style="text-align: center; vertical-align: middle;"
                                   >
                                   <input type="checkbox">
                            </v-col>
                        </v-col>
                        <!-- fin de icono -->
                    </v-row>
                </v-card>
            </v-col>
            <!-- fin de tarjeta Alerta Web -->

            <!-- inicio de tarjeta SMS -->
            <v-col no-gutters cols="12" class="pa-0 my-2">
                <v-card class="pa-0 ma-0">
                    <v-row class="card-width" no-gutters>
                        <!-- inicio de texto -->
                        <v-col cols="8"
                               class="pa-2 card-text">
                               Un <b>mensaje de texto</b> se te hara llegar a tu celular cuando, como parte de tu membresía. <br>Ver membresías
                        </v-col>
                        <!-- fin de texto -->

                        <!-- inicio de icono -->
                        <v-col cols="4"
                               class="ltl-card-header-alert std-border-right-radius pa-2 align-center justify-center card-width"
                               >
                            <v-col cols="12"
                                   class="ltl-card-icon-container no-gutters mx-auto mt-0 pa-0 d-flexs align-end icon-container-heat">
                                <img src="../assets/Icon_SMS.svg" alt="#"/>
                            </v-col>
                            <v-col class="pa-0 ma-0 pt-1"
                                   no-padding
                                   style="text-align: center; vertical-align: middle;"
                                   >
                                   <input type="checkbox">
                            </v-col>
                        </v-col>
                        <!-- fin de icono -->
                    </v-row>
                </v-card>
            </v-col>
            <!-- fin de tarjeta SMS -->

            <!-- inicio de tarjeta Notificacion -->
            <v-col no-gutters cols="12" class="pa-0 my-2">
                <v-card class="pa-0 ma-0">
                    <v-row class="card-width" no-gutters>
                        <!-- inicio de texto -->
                        <v-col cols="8"
                               class="pa-2 card-text">
                               Esto es una <b>notificacion</b> igual a las otras aplicaciones que tienes en tu celular.
¡Super practica!
                        </v-col>
                        <!-- fin de texto -->

                        <!-- inicio de icono -->
                        <v-col cols="4"
                               class="ltl-card-header-alert std-border-right-radius pa-2 align-center justify-center card-width"
                               >
                            <v-col cols="12"
                                   class="ltl-card-icon-container no-gutters mx-auto mt-0 pa-0 d-flexs align-end icon-container-heat">
                                <img src="../assets/Icon_Notification.svg" alt="#"/>
                            </v-col>
                            <v-col class="pa-0 ma-0 pt-1"
                                   no-padding
                                   style="text-align: center; vertical-align: middle;"
                                   >
                                   <input type="checkbox">
                            </v-col>
                        </v-col>
                        <!-- fin de icono -->
                    </v-row>
                </v-card>
            </v-col>
            <!-- fin de tarjeta Notificacion -->

            <!-- inicio de controles inferiores -->
            <v-row cols="12" class="d-flex align-center justify-center" no-gutters>
                <v-col cols="4" class="d-flex align-center justify-start icon-container-arrows">
                    <img src="../assets/Arrow_Left.svg" alt="#"/>
                </v-col>

                <v-col cols="4" class="d-flex align-center justify-center">
                    <v-btn text class="my-2 d-flex std-text-grey">
                        Omitir paso
                    </v-btn>
                </v-col>

                <v-col cols="4" class="d-flex align-center justify-end icon-container-arrows full-height">
                    <img src="../assets/Arrow_Right.svg" alt="#"/>
                </v-col>
            </v-row>
            <!-- fin de controles inferiores -->


        </v-row>


        <!-- fin de tarjetas de alertas -->

    </v-container>
</template>

<script>
    import ChangeRanch from '@/components/ChangeRanch.vue';
    export default {
      name: 'MobileComponents',
        data () {
          return {
          }
      },
      components: {
        ChangeRanch
      },
      computed: {
      },
      methods: {
      },
      mounted () {
      }
    };
</script>
    
<style lang="css">
    @import '../style/MobileAlertsSelection.css';
    @import '../style/BaseStyle.css';
</style>